import React from 'react'
import styled from 'styled-components/macro'
import { t } from 'ttag'
import 'rc-pagination/assets/index.css'
import Pagination from 'rc-pagination'
import enUS from 'rc-pagination/es/locale/en_US'
import breakpoints from 'assets/stylesheet'

const StyledPagination = styled(Pagination)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 10px !important;
  margin-top: 10px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),
    0 1px 3px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  & > li {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .rc-pagination-options {
    margin-left: 0;
  }
  .rc-pagination-item {
    &:hover {
      background-color: #9faee5;
      border-color: #9faee5;
      a {
        color: white;
      }
    }
  }
  .rc-pagination-item-active {
    background-color: #9faee5;
    border-color: #9faee5;
  }
  .rc-pagination-jump-prev:hover:after,
  .rc-pagination-jump-next:hover:after {
    color: #9faee5;
  }
  .rc-pagination-options-quick-jumper button:hover,
  .rc-pagination-options-quick-jumper button:active,
  .rc-pagination-options-quick-jumper button:focus {
    color: #9faee5;
    background-color: #fff;
    border-color: #9faee5;
  }
  .rc-pagination-options-quick-jumper {
    font-family: 'Open Sans' !important;
    @media (max-width: ${breakpoints.bpTabletPx}) {
      display: none;
    }
  }
  .rc-pagination-options-quick-jumper input:hover {
    border-color: #9faee5;
  }
  .rc-pagination-options-quick-jumper button {
    background-color: #9faee5 !important;
    color: white !important;
  }
`

function CustomPagination({
  onPageChange,
  count,
  current
}: {
  onPageChange: () => void,
  count: number,
  current: number
}) {
  return (
    <StyledPagination
      showQuickJumper={{ goButton: <button type="button">{t`Go`}</button> }}
      defaultPageSize={30}
      defaultCurrent={1}
      current={current}
      onChange={onPageChange}
      total={count}
      locale={enUS}
      showLessItems
    />
  )
}

export default CustomPagination
